import { render } from "./AssessmentProgress.vue?vue&type=template&id=55b68b84&scoped=true"
import script from "./AssessmentProgress.vue?vue&type=script&lang=js"
export * from "./AssessmentProgress.vue?vue&type=script&lang=js"

import "./AssessmentProgress.vue?vue&type=style&index=0&id=55b68b84&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b68b84"]])

export default __exports__